import { useQuery } from 'customHooks';

import { useGet } from 'customHooks/api';

export const useGetUfs = () => {
  const getUfs = useGet('ufs');
  return useQuery(['ufs'], getUfs);
};
